import React from 'react'
import "./LpExp.css"
import LpExpHead from './LpExpHead'
import LpExpMain from './LpExpMain'
const LpExp = () => {
  return (
    <div className='lpExp-container'>
      <LpExpHead/>
      <LpExpMain/>
    </div>
  )
}

export default LpExp
